var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"copyRight"},[_vm._v("Copyright ⓒ e-CLUB 전자사랑모임. All Rights Reserved.")])])}]

export { render, staticRenderFns }